export default() => {
    // Early exit if the gallery class does not exist.
    if($('.location-page__main__gallery').length === 0) {
        return;
    }

    let slideIndex = 1;

    /**
     * Functions to load on ready
     */
    $(document).ready(function() {
        showSlides(slideIndex);
    });

    $(
        `.location-page__main__gallery__button, 
        .location-page__main__gallery__light-box__close, 
        .location-page__main__gallery__images`
    ).on('click', function(e) {
        e.preventDefault();

        // Open specific image when gallery images are clicked.
        if ($(this).hasClass('grid-class-one')) {
            currentSlide(1);
        } else if ($(this).hasClass('grid-class-two')) {
            currentSlide(2);
        } else if ($(this).hasClass('grid-class-three')) {
            currentSlide(3);
        }

        toggleLightboxGallery();

    });

    $('.location-page__main__gallery__light-box__modal__column').on('click', function() {
        currentSlide($(this).data('slide'));
    });

    $('.location-page__main__gallery__light-box__modal__prev').on('click', function() {
        plusSlides(-1);
    });

    $('.location-page__main__gallery__light-box__modal__next').on('click', function() {
        plusSlides(1);
    });

    /**
     * Toggle Lightbox gallery to show or hide
     */
    function toggleLightboxGallery() {
        const lightBox = $('#location-page__main__gallery__light-box');

        if (lightBox.is(':visible')) {
            lightBox.hide();
        } else {
            lightBox.show();
        }
    }

    /**
     * Next/Previous slide controls
     *
     * @param n
     */
    function plusSlides(n) {
        showSlides(slideIndex += n);
    }

    /**
     * Show current slide
     *
     * @param n
     */
    function currentSlide(n) {
        showSlides(slideIndex = n);
    }

    /**
     * Show and hide slides in lightbox gallery
     *
     * @param n index
     */
    function showSlides(n) {
        const slides = $(".location-page__main__gallery__light-box__modal__slides");
        const dots = $(".location-page__main__gallery__light-box__modal__column__thumbnail");
        const captions = $(".location-page__main__gallery__light-box__modal__caption");

        if (n > slides.length) {
            slideIndex = 1;
        }

        if (n < 1) {
            slideIndex = slides.length
        }

        slides.hide();
        captions.hide();
        dots.removeClass('active');

        if (slides.eq(slideIndex - 1)) {
            slides.eq(slideIndex - 1).show();
        }

        if (captions.eq(slideIndex - 1)) {
            captions.eq(slideIndex - 1).show();
        }

        if (dots.eq(slideIndex - 1)) {
            dots.eq(slideIndex - 1).addClass('active');
        }
    }
}